module.exports = "<section class=\"widget ads-txt-wrapper\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Ads.txt</span></h1>\r\n  <div class=\"form-group\">\r\n    <textarea ng-model=\"vmat.adsTxt\" plceholder=\"Ads.txt\" class=\"form-control\"></textarea>\r\n  </div>  \r\n  <a ng-click=\"vmat.saveChanges()\" class=\"btn btn-primary pull-right\">Save Changes</a>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/adsTxt/js/directive/partial/adsTxt.html
// module id = 254
// module chunks = 0